/** Vue 引入的 vant */
import "../assets/style/var.less";
import "../assets/style/icon-font.css";
import "../assets/style/b-icon-font.css";
import "../assets/style/custom.less";
import Vue from "vue";
import {
    Notify,
    Toast,
    Dialog,
    Tabbar,
    TabbarItem,
    Tag,
    Button,
    Loading,
    Cell,
    CellGroup,
    Form,
    Field,
    Overlay,
    RadioGroup,
    Radio,
    Checkbox,
    CheckboxGroup,
    Uploader,
    PasswordInput,
    NumberKeyboard,
    ActionSheet,
    Switch,
    Search,
    Icon,
    Divider,
    DatetimePicker,
    Tab,
    Tabs,
    Col,
    Row,
    Empty,
    List,
    PullRefresh,
    ImagePreview,
    Swipe, 
    SwipeItem
} from "vant";
Vue.use(Tabbar)
    .use(TabbarItem)
    .use(Tag)
    .use(Button)
    .use(Loading)
    .use(Cell)
    .use(CellGroup)
    .use(Form)
    .use(Field)
    .use(Dialog)
    .use(Overlay)
    .use(RadioGroup)
    .use(Radio)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Toast)
    .use(Uploader)
    .use(PasswordInput)
    .use(NumberKeyboard)
    .use(ActionSheet)
    .use(Switch)
    .use(Search)
    .use(Icon)
    .use(Divider)
    .use(DatetimePicker)
    .use(Tab)
    .use(Tabs)
    .use(Row)
    .use(Col)
    .use(Notify)
    .use(Empty)
    .use(List)
    .use(PullRefresh)
    .use(ImagePreview)
    .use(Swipe)
    .use(SwipeItem);
Toast.setDefaultOptions("text", {
    position: "bottom",
});
